import { create } from 'zustand';
import type { Partner } from '../types';

interface AuthState {
  partner: Partner | null;
  token: string | null;
  setAuth: (partner: Partner, token: string) => void;
  setAccessToken: (token: string) => void;
  clear: () => void;
}

// Anyone signed in before this change still has a refresh token sitting in
// localStorage under the old key. Drop it on load — otherwise the exposure this
// change removes survives until the user happens to clear site data.
localStorage.removeItem('partner_auth');

/**
 * Nothing is persisted. The refresh token lives in an httpOnly cookie the page
 * cannot read, and the access token is held in memory only — so a reload has to
 * mint a fresh one via /partner/auth/refresh, which also returns the partner.
 */
export const useAuthStore = create<AuthState>((set) => ({
  partner: null,
  token: null,
  setAuth: (partner, token) => set({ partner, token }),
  setAccessToken: (token) => set({ token }),
  clear: () => set({ partner: null, token: null }),
}));
